import Decimal from 'decimal.js';
import { reduce } from '@fxts/core';

export class CalcDecimalCore {
  static calc(method: 'plus' | 'minus' | 'mul' | 'div') {
    return (a: string | number, ...args: (string | number)[]) => {
      try {
        const d_a = new Decimal(a || 0);
        return reduce((acc, arg) => acc[method](arg), d_a, args).toNumber();
      } catch (err) {
        console.error(`plus: ${a}, ${args}`);
        throw err;
      }
    };
  }

  static plus = CalcDecimalCore.calc('plus');
  static minus = CalcDecimalCore.calc('minus');
  static mul = CalcDecimalCore.calc('mul');
  static div = CalcDecimalCore.calc('div');
}
